import {reduxForm, Field} from 'redux-form'
import UploadImage from 'components/Fields/ReduxForm/UploadImage'
import SettingField from 'components/Fields/ReduxForm/SettingField'
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField'
import styles from './StaffForm.css'
import ActionBarDetailWrapper from 'components/wrappers/pages/ActionBarDetailWrapper'
import LabelSection from 'components/sections/LabelSection'
import gravatarDefault from 'assets/images/account-profile-default.jpg'
import {onClickCancel} from 'actions/employees/staff'
import AssignPasscode from './AssignPasscode'
import EmailField from './EmailField'
import validator from 'validator'

const validate = (values) => {
  const errors = {}
  // validate first_name
  if (!values.first_name) {
    errors.first_name = 'First Name is Required'
  } else if (values.first_name.length > 20) {
    errors.first_name = 'First Name must be less than 20 characters'
  }
  // validate last name
  if (!values.last_name) {
    errors.last_name = 'Last Name is Required'
  } else if (values.last_name.length > 30) {
    errors.last_name = 'Last Name must be less than 30 characters'
  }
  // validate email
  if (!values.email) {
    errors.email = 'Email is Required'
  } else if (!validator.isEmail(values.email)) {
    errors.email = 'Your email is not valid, please check the format'
  }
  // validate pin length
  if (values.assign_pin && (!values.pin || values.pin.length < 4)) {
    errors.pin = 'Please enter at least 4 characters'
  }
  return errors
}
class StaffForm extends React.Component {
  render () {
    const emailConfirmed = this.props.employee && this.props.employee.is_email_confirmed
    const hashedOutlets = {}
    if (this.props.formValues && this.props.formValues.outlets) {
      this.props.formValues.outlets.forEach((oid) => {
        hashedOutlets[`${oid}`] = true
      })
    }
    const {selfView} = this.props
    const selectedOutlets = this.props.outlets.filter((outlet) => hashedOutlets[`${outlet.id}`])
    return <div className={styles.wrapper}>
      <div className={`${styles['field-wrapper']} staff-field-wrapper`}>
        <LabelSection title='Invite Employee' />
        <div className='row'>
          <Field
            name='photo_url'
            component={UploadImage}
            className={styles['upload-image']}
            defaultImage={gravatarDefault}
            imageContainerClassName={styles['upload-image-content']}
            confirmOnDelete
          />
          <div className={`${styles['side-image-wrapper']}`}>
            <div className='row'>
              <div className='col-md-6' style={{paddingRight: '8px'}}>
                <div className='form-group'>
                  <Field
                    name='first_name'
                    component={SettingField}
                    placeholder='First Name'
                  />
                </div>
              </div>
              <div className='col-md-6' style={{paddingLeft: '8px'}}>
                <div className='form-group'>
                  <Field
                    name='last_name'
                    component={SettingField}
                    placeholder='Last Name'
                  />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-xs-12'>
                <div className='form-group'>
                  {emailConfirmed && <input
                    className='form-control'
                    value={this.props.formValues.email}
                    disabled
                  />}
                  {!emailConfirmed && <Field
                    name='email'
                    component={EmailField}
                    readOnly={selfView}
                  />}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-xs-12'>
                <div className='form-group'>
                  <Field
                    component={PhoneNumberField}
                    name='phone'
                    type='tel'
                    placeholder='812'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* prevent firefox to recognize this form as a login form, we must separate 'text' and 'password' input */}
        <input type='text' style={{display: 'none'}} />
        <LabelSection title='Employee Role' />
        <div className='row'>
          <div className='col-xs-12'>
            <div className='form-group'>
              {!selfView && <Field
                component='select'
                name='role_id'
                className={`form-control ${styles.role}`}
              >
                <option hidden value=''>- Select Role -</option>
                {this.props.roles.map((role) => {
                  return <option value={role.id}>{role.name}</option>
                })}
              </Field>}
              {selfView && <select className={`form-control ${styles.role}`} disabled>
                <option>{this.props.employee.role.name}</option>
              </select>}
            </div>
          </div>
          <div className='col-xs-12'>
            <AssignPasscode
              assignPin={this.props.formValues.assign_pin}
              selfView={selfView}
              dispatch={this.props.dispatch}
              currentPin={this.props.formValues.pin}
            />
          </div>
        </div>
        <div className='row mt-20px' />
        <LabelSection title='Assigned outlets' />
        <Field
          name='outlets'
          type='hidden'
          component='input'
        />
        <div className='row'>
          {selectedOutlets.map((outlet) => <div className={`col-xs-12 ${styles['outlet-name']}`}>{outlet.name}</div>)}
          <div className='col-xs-12'>
            <button className='btn btn-primary btn-block'
              onClick={() => { if (!selfView) this.props.onClickAssignOutlet() }}
              disabled={selfView}
            >
              Assign Outlet
            </button>
          </div>
        </div>
        <div className='row mt-20px' />
        <LabelSection title='Description' />
        <div className='row'>
          <div className='col-xs-12'>
            <Field
              name='description'
              component='textarea'
              placeholder='Join date : 01 January 2017'
              className='form-control'
              rows='3'
            />
          </div>
        </div>
      </div>
      <ActionBarDetailWrapper>
        <span className='pull-left'>
          {this.props.formValues && this.props.formValues.id && <button className='btn btn-danger'
            onClick={this.props.onClickDeleteEmployee} disabled={this.props.selfView}>
            <span className='fa fa-trash' />
          </button>}
        </span>
        <span className='pull-right'>
          <button type='button' className='btn btn-default mr-10px' onClick={this._onClickCancel}>Cancel</button>
          <button type='button'
            className='btn btn-primary'
            onClick={this.props.handleSubmit(this._onSubmit)}
            disabled={this.props.disableSubmit}
          >
            {this.props.formValues.id ? 'Save' : 'Invite' }
          </button>
        </span>
      </ActionBarDetailWrapper>
    </div>
  }

  _onSubmit = (values) => {
    this.props.onSubmit({values})
  }

  _onClickCancel = () => {
    this.props.dispatch(onClickCancel())
  }
}

const mapForm = {
  form: 'staff',
  validate,
  touchOnChange: true
}

StaffForm.propTypes = {
  outlets: React.PropTypes.array,
  onClickAssignOutlet: React.PropTypes.func,
  onSubmit: React.PropTypes.func,
  employee: React.PropTypes.object,
  roles: React.PropTypes.array,
  formValues: React.PropTypes.object,
  onClickDeleteEmployee: React.PropTypes.func,
  selfView: React.PropTypes.bool,
  disableSubmit: React.PropTypes.bool
}

StaffForm.defaultProps = {
  selfView: true
}

export default (reduxForm(mapForm)(StaffForm))



// WEBPACK FOOTER //
// ./app/pages/Employees/Staff/StaffDetail/StaffForm/StaffForm.js